module.exports = __webpack_public_path__ + "static/media/ZE.bbca2108.pdf";